/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminProfileResponseDto
 */
export interface AdminProfileResponseDto {
    /**
     * Admin ID (same as user ID)
     * @type {string}
     * @memberof AdminProfileResponseDto
     */
    id: string;
    /**
     * Admin email address
     * @type {string}
     * @memberof AdminProfileResponseDto
     */
    email: string;
    /**
     * Admin first name
     * @type {string}
     * @memberof AdminProfileResponseDto
     */
    firstName: string;
    /**
     * Admin middle name
     * @type {string}
     * @memberof AdminProfileResponseDto
     */
    middleName?: string;
    /**
     * Admin last name
     * @type {string}
     * @memberof AdminProfileResponseDto
     */
    lastName: string;
    /**
     * Admin phone number
     * @type {string}
     * @memberof AdminProfileResponseDto
     */
    phone?: string;
    /**
     * Admin avatar URL
     * @type {string}
     * @memberof AdminProfileResponseDto
     */
    avatar?: string;
}

/**
 * Check if a given object implements the AdminProfileResponseDto interface.
 */
export function instanceOfAdminProfileResponseDto(value: object): value is AdminProfileResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function AdminProfileResponseDtoFromJSON(json: any): AdminProfileResponseDto {
    return AdminProfileResponseDtoFromJSONTyped(json, false);
}

export function AdminProfileResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProfileResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'avatar': json['avatar'] == null ? undefined : json['avatar'],
    };
}

export function AdminProfileResponseDtoToJSON(json: any): AdminProfileResponseDto {
    return AdminProfileResponseDtoToJSONTyped(json, false);
}

export function AdminProfileResponseDtoToJSONTyped(value?: AdminProfileResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'phone': value['phone'],
        'avatar': value['avatar'],
    };
}

